import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {EventosTablaInterface} from '../../interfaces/eventos-tabla.interface';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import * as swalFunctions from '../../data/sweet-alerts'
import {ComboBoxInterface} from '../../interfaces/combo-box.interface';
import {ParametrosTablaInterface} from '../../interfaces/parametros-tabla.interface';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Reglux} from '../../reglux/reglux';
import {Constants} from '../../constants/constants';
import {ComboBoxService} from '../../services/combo-box.service';
import {FilesService} from '../../services/files.service';
import {HttpEventType, HttpResponse} from '@angular/common/http';
import swal from 'sweetalert2';
import {PsadjterService} from '../../services/psadjter.service';
import {FiadjretService} from '../../services/fiadjret.service';
import {FiadjmovService} from '../../services/fiadjmov.service';
import {FiadjinvService} from '../../services/fiadjinv.service';


@Component({
  selector: 'app-modal-documentos',
  templateUrl: './modal-documentos.component.html',
  styleUrls: ['./modal-documentos.component.scss']
})
export class ModalDocumentosComponent implements OnInit, AfterViewInit {

  @ViewChild('modalDocumentos') modal: ElementRef;
  @Output() emitter: EventEmitter<EventosTablaInterface> = new EventEmitter<EventosTablaInterface>();
  @Input() evento: EventosTablaInterface;

  // Formulario
  adjunto: FormGroup;

  // Variables
  guardado = false;
  swal = swalFunctions;
  eventoResponse: EventosTablaInterface;
  nombre: string;
  selectedFiles: FileList;
  messageFiles: string;
  listGltipadj: ComboBoxInterface[];
  procesando = false;
  id: number;

  parametrosTabla: ParametrosTablaInterface = {
    dataSource: [],
    displayedColumns: ['tipoAdjunto', 'comentarios', 'fecha', this.constants.VISUALIZAR, this.constants.ELIMINAR_DOCUMENTACION],
    dataNames: ['Documento'],
    formatColumn: [this.constants.TEXT, this.constants.TEXT, this.constants.DATETIME, this.constants.CONTROL, this.constants.CONTROL],
    pageSize: 5,
    pageSizeOptions: [5, 10, 25, 100],
    clasePaginator: 'col-md-12',
    documentacion: true,
    botonActualizar: true
  }


  constructor(private modalService: NgbModal,
              private formBuilder: FormBuilder,
              private reglux: Reglux,
              private cd: ChangeDetectorRef,
              private constants: Constants,
              private _comboBox: ComboBoxService,
              private _files: FilesService,
              private _psadjter: PsadjterService,
              private _fiadjter: FiadjretService,
              private _fiadjmov: FiadjmovService,
              private _fiadjinv: FiadjinvService ) {
  }

  ngOnInit(): void {
    this.updateData();
    this.initForm();
  }

  ngAfterViewInit(): void {
    this.modalService.open(this.modal, {
      backdrop: 'static',
      keyboard: false,
      size: 'lg'
    });

    switch (this.evento.tablaAdjuntos.trim()) {
      case this.constants.PSADJTER:
        if (this.evento.objeto.idregfis == 1) {
          this.nombre = this.evento.objeto.nombres + ' ' + this.evento.objeto.apellidoPaterno + ' ' + this.evento.objeto.apellidoMaterno;
        } else {
          this.nombre = this.evento.objeto.razonSocial;
        }
        break;

      case this.constants.FICORRET:
        this.nombre = this.evento.objeto.tipoMovimiento;
        break;
      case this.constants.FIMOVIMI:
        this.nombre = 'Folio Factura:' + this.evento.objeto.folioFactura;
        break;
      case this.constants.FIMOVINV:
        this.nombre = 'Fecha Egreso' + this.evento.objeto.fecha;
        break;
    }
    this.parametrosTabla.tabla = this.evento.tabla;
  }

  emit(): void {
    this.evento = {
      accion: ''
    }
    this.emitter.emit(this.evento);
  }

  initForm(): void {
    this.adjunto = this.formBuilder.group({
      idtipadj: ['', [Validators.required]],
      archivo: [''],
      comentarios: ['', [Validators.maxLength(255)]],
      id: [this.id]
    });
  }

  validateRecord(): boolean {
    if (this.selectedFiles == null) {
      this.swal.TypeError('Sin Archivo', 'Es necesario carga un archivo en formato .pdf valido.');
      return false;
    }
    return true;
  }

  saveOrUpdateRecord(): boolean {
    if (this.validateRecord() === false) {
      return false;
    }
    this.procesando = true;
    this.guardado = true;
    this.uploadFiles();
    return true;
  }

  deleteRecord(): void {

    swal.fire({
      title: '¿Desea eliminar el registro seleccionado?',
      text: '¡No podrás revertir esto!',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, continuar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
        if (result.isConfirmed) {
          this.procesando = true;
          this._files.deleteSFTPBD(this.eventoResponse.objeto.archivo, this.evento.rutaSFTP, this.evento.tablaAdjuntos, this.eventoResponse.objeto.idadjunt)
            .subscribe(res => {
              this.updateData();
              this.swal.TypeSuccess('Archivo eliminado', 'Verifique la información');
              this.cd.markForCheck();
              this.procesando = false;
            }, error => {
              this.swal.TypeErrorDetails(error.error.message, error.error.trace);
              this.procesando = false;
            });

        }
      }
    );
  }

  validateField(campo: string, codigoError: string): boolean {
    return this.adjunto.get(campo).hasError(codigoError);
  }

  responseEmitter(evento: EventosTablaInterface): void {
    this.eventoResponse = evento;
    switch (this.eventoResponse.accion.trim()) {
      case this.constants.VISUALIZAR:
        this.getFilePDF();
        break;
      case this.constants.ELIMINAR_DOCUMENTACION:
        this.deleteRecord();
        break;
      case this.constants.ACTUALIZAR_TABLA:
        this.updateData();
        break;
    }

  }

  selectFiles(event): void {
    for (const file of event.target.files) {
      if (file.name.split('.').pop().toLowerCase() !== 'pdf' && file.name.split('.').pop().toLowerCase() !== 'xml') {
        this.selectedFiles = null;
        this.swal.TypeError('Error en extensión', 'Verifique la extensión de los archivos adjuntos, las extensiones permitidas son (.pdf,.xml)');
        return;
        break;
      }
    }
    this.selectedFiles = event.target.files;
  }


  uploadFiles(): void {
    for (let i = 0; i < this.selectedFiles.length; i++) {
      this.upload(this.selectedFiles[i]);
    }
  }

  upload(file): void {
    this.procesando = true;
    this._files.uploadOptimizado(file, this.evento.tablaAdjuntos, this.evento.rutaSFTP, this.adjunto.value).subscribe(
      event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.selectedFiles = null;
        } else if (event instanceof HttpResponse) {
          this.selectedFiles = null;
          this.swal.TypeSuccess('Archivo cargado', 'Verifique la información.');
        }

        this.cd.markForCheck();
        this.initForm();
        this.guardado = false;
        this.procesando = false;
        this.updateData();
      },
      err => {
        this.messageFiles = 'No se puede subir el archivo ' + file.name;
        this.swal.TypeError('Error Carga', this.messageFiles);
        this.guardado = false;
        this.procesando = false;
      });

  }

  getFilePDF(): void {
    this.procesando = true;
    this._files.getArchivo(this.eventoResponse.objeto.archivo, this.evento.rutaSFTP).subscribe(() => {
      window.open(this.constants.URL_VER_PDF + this.eventoResponse.objeto.archivo, '_blank');
      this.procesando = false;
    }, error => this.swal.TypeErrorDetails(error.error.message, error.error.trace));
  }

  updateData(): void {

    switch (this.evento.tablaAdjuntos.trim()) {
      case this.constants.PSADJTER:
        this.id = this.evento.objeto.idtercer;
        this.getListPsadjterByIdtercer();
        this.loadComboGltipadjByAplicaAdherentes();
        break;
      case this.constants.FICORRET:
        this.id = this.evento.objeto.idcorret;
        this.getListFicorretByIdcorret();
        this.loadComboGltipadjByFicorret();
        break;
      case this.constants.FIMOVIMI:
        this.id = this.evento.objeto.idmovimi;
        this.getListFimovimiByIdmovimi();
        this.loadComboGltipadjByFimovimi();
        break;
      case this.constants.FIMOVINV:
        this.id = this.evento.objeto.idmovinv;
        this.getListFiadjinvByIdmovinv();
        this.loadComboGltipadjByFimovinv();
        break;
    }
  }

  isGranted(): boolean {
    /*if (this.evento.tablaAdjuntos !== undefined) {
      return this._tablaValidaciones.isGranted(this.evento.tablaAdjuntos.trim(), this.constants.AGREGAR, true);
    } else {
      return false;
    }*/
    return true;
  }


  loadComboGltipadjByAplicaAdherentes(): void {
    this._comboBox.getListGltipadjByAplicaAdherentes(this.evento.objeto.idtercer).subscribe(res => {
      this.listGltipadj = res;
      this.cd.markForCheck();
    }, error => this.swal.TypeErrorDetails(error.error.message, error.error.trace));
  }

  loadComboGltipadjByFicorret(): void {
    this._comboBox.loadComboGltipadjByFicorret(this.evento.objeto.idcorret).subscribe(res => {
      this.listGltipadj = res;
      this.cd.markForCheck();
    }, error => this.swal.TypeErrorDetails(error.error.message, error.error.trace));
  }

  loadComboGltipadjByFimovimi(): void {
    this._comboBox.loadComboGltipadjByFimovimi(this.evento.objeto.idmovimi).subscribe(res => {
      this.listGltipadj = res;
      this.cd.markForCheck();
    }, error => this.swal.TypeErrorDetails(error.error.message, error.error.trace));
  }

  loadComboGltipadjByFimovinv(): void {
    this._comboBox.loadComboGltipadjByFimovinv(this.evento.objeto.idmovinv).subscribe(res => {
      this.listGltipadj = res;
      this.cd.markForCheck();
    }, error => this.swal.TypeErrorDetails(error.error.message, error.error.trace));
  }


  getListPsadjterByIdtercer(): void {
    this._psadjter.getListPsadjterByIdtercer(this.evento.objeto.idtercer).subscribe(res => {
      this.parametrosTabla.dataSource = res;
      this.parametrosTabla.evento = {
        accion: this.constants.ACTUALIZAR_TABLA
      }
      this.cd.markForCheck();
    });
  }

  getListFicorretByIdcorret(): void {
    this._fiadjter.getListFicorretByIdcorret(this.evento.objeto.idcorret).subscribe(res => {
      this.parametrosTabla.dataSource = res;
      this.parametrosTabla.evento = {
        accion: this.constants.ACTUALIZAR_TABLA
      }
      this.cd.markForCheck();
    });
  }

  getListFimovimiByIdmovimi(): void {
    this._fiadjmov.getListFimovimiByIdmovimi(this.evento.objeto.idmovimi).subscribe(res => {
      this.parametrosTabla.dataSource = res;
      this.parametrosTabla.evento = {
        accion: this.constants.ACTUALIZAR_TABLA
      }
      this.cd.markForCheck();
    });
  }

  getListFiadjinvByIdmovinv(): void {
    this._fiadjinv.getListFiadjmovByIdmovinv(this.evento.objeto.idmovinv).subscribe(res => {
      this.parametrosTabla.dataSource = res;
      this.parametrosTabla.evento = {
        accion: this.constants.ACTUALIZAR_TABLA
      }
      this.cd.markForCheck();
    });
  }

}
